module.exports = __webpack_public_path__ + "static/media/icon-check-mark-white.c8d74a71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-check-mark-white.svg
// module id = 826
// module chunks = 0